import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { CriterioAvaliacaoRotinaCliente } from '../../comum/modelos/criterio-avaliacao-rotina-cliente';
import { Ocorrencia } from '../../comum/modelos/ocorrencia';
import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { ProcessoSetor } from '../../comum/modelos/processo-setor';
import { RotinaProcesso } from '../../comum/modelos/rotina-processo';
import { SetorPontoFisico } from '../../comum/modelos/setor-ponto-fisico';
import { StatusOcorrencia } from '../../comum/modelos/status-ocorrencia';
import { TipoOcorrencia } from '../../comum/modelos/tipo-ocorrencia';
import { Usuario } from '../../comum/modelos/usuario';
import { PontoFisicoService } from '../../ponto-fisico/ponto-fisico.service';
import { ProcessoService } from '../../processo/processo.service';
import { RotinaService } from '../../rotina/rotina.service';
import { SetorService } from '../../setor/setor.service';
import { UsuarioService } from '../../usuario/usuario.service';
import { OcorrenciasService } from '../ocorrencias.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';
import { AreaCliente } from '../../comum/modelos/area-cliente';
import { ClienteService } from '../../cliente/cliente.service';

@Component({
  selector: 'app-cadastro-ocorrencia',
  templateUrl: './cadastro-ocorrencia.component.html',
  styleUrls: ['./cadastro-ocorrencia.component.css']
})
export class CadastroOcorrenciaComponent implements OnInit {

  areasCliente: AreaCliente[];
  pontosFisicos: PontoFisico[];
  setores: SetorPontoFisico[];
  processos: ProcessoSetor[];
  rotinas: RotinaProcesso[];
  criteriosAvaliacaoRotina: CriterioAvaliacaoRotinaCliente[];
  usuarios: Usuario[];
  ocorrencia: Ocorrencia;
  areaCliente: AreaCliente;
  tiposOcorrencia: TipoOcorrencia[];
  statusOcorrencia: StatusOcorrencia[];
  imagem: File;

  statusCode: number;
  selecionados: boolean;

  public evento: Evento;
  public paginacao: Paginacao;

  public loading = false;

  constructor(
    private _comumService: ComumService,
    private _pontoFisicoService: PontoFisicoService,
    private _setorService: SetorService,
    private _processoService: ProcessoService,
    private _rotinaService: RotinaService,
    private _usuarioService: UsuarioService,
    private _ocorrenciasService: OcorrenciasService,
    private _clienteService: ClienteService,
    private router: Router,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.areasCliente = new Array<AreaCliente>();
    this.pontosFisicos = new Array<PontoFisico>();
    this.setores = new Array<SetorPontoFisico>();
    this.processos = new Array<ProcessoSetor>();
    this.rotinas = new Array<RotinaProcesso>();
    this.criteriosAvaliacaoRotina = new Array<CriterioAvaliacaoRotinaCliente>();
    this.usuarios = new Array<Usuario>();
    this.ocorrencia = new Ocorrencia();
    this.areaCliente = new AreaCliente();
    this.tiposOcorrencia = new Array<TipoOcorrencia>();
    this.statusOcorrencia = new Array<StatusOcorrencia>();
    this.evento = this._comumService.evento;
    this.paginacao = new Paginacao();
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;
    const idCliente = parseInt(this._cookieService.get('idCliente'), 10);
    const usuario = JSON.parse(this._cookieService.get('usuario'));
    const self = this;

    forkJoin(
      this._clienteService.obterAreasUsuarioHttp(usuario.idUsuario),
      this._usuarioService.obterUsuariosHttp(idCliente),
      this._ocorrenciasService.obterStatusOcorrenciasHttp(),
      this._ocorrenciasService.obterTipoOcorrenciaHttp())
      .subscribe(([areasCliente, usuarios, status, tipos]) => {
        this.areasCliente = areasCliente;
        this.usuarios = usuarios;
        this.statusOcorrencia = status;
        this.tiposOcorrencia = tipos;
        self.loading = false;
      });
  }

  onSubmit(): void {
    this.loading = true;
    const self = this;
    this.ocorrencia.dataAberturaString = new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
    this.ocorrencia.tipoOcorrencia = this.tiposOcorrencia.find(tipo => tipo.descricaoTipoOcorrencia === 'Manual');
    this.ocorrencia.statusOcorrencia = this.statusOcorrencia.find(status => status.descricaoStatusOcorrencia === 'Aberto');
    this.ocorrencia.idCliente = parseInt(this._cookieService.get('idCliente'), 10);
    this._ocorrenciasService.cadastrarOcorrenciaHttp(this.ocorrencia, this.imagem)
      .subscribe(response => {
        this.loading = false;
        this.statusCode = response.status;
        this._comumService.evento.cadastro = true;
        this.router.navigate(['detalhe-ocorrencia/' + response.body.idOcorrencia, 'BAIXA']);
      }, errorCode => {
        this.statusCode = errorCode;
        this.loading = false;
      });
  }

  selecionarPontosFisicos(idArea: number): void {
    this.loading = true;
    const ids = [idArea];
    this._pontoFisicoService.obterPontosFisicosAreaHttp(ids)
      .subscribe((pontosFisicos) => {
        this.pontosFisicos = pontosFisicos;
        this.loading = false;
      });
  }

  selecionarSetores(idPontoFisico: number): void {
    this.loading = true;
    this._setorService.obterSetoresPontoFisicoHttp(idPontoFisico)
      .subscribe((setoresPontoFisico) => {
        this.setores = setoresPontoFisico;
        this.loading = false;
      });
  }

  selecionarProcessos(idSetorPontoFisico: number): void {
    this.loading = true;
    this._processoService.obterProcessosSetorHttp(idSetorPontoFisico)
      .subscribe((processosSetor) => {
        this.processos = processosSetor;
        this.loading = false;
      });
  }

  selecionarRotinas(idProcessoSetor: number): void {
    this.loading = true;
    this._rotinaService.obterRotinasProcessoHttp(idProcessoSetor)
      .subscribe((rotinasProcesso) => {
        this.rotinas = rotinasProcesso;
        this.loading = false;
      });
  }

  selecionarCriteriosAvaliacaoRotina(idRotinaProcesso: number): void {
    this.loading = true;
    let idRotinaCliente = 0;
    for (const rotinaProcesso of this.rotinas) {
      if (rotinaProcesso.idRotinaProcesso.toString() === idRotinaProcesso.toString()) {
        idRotinaCliente = rotinaProcesso.rotinaCliente.idRotinaCliente;
        break;
      }
    }
    this._rotinaService.obterCriteriosAvaliacaoRotinaClienteHttp(idRotinaCliente)
      .subscribe((criterios) => {
        this.criteriosAvaliacaoRotina = criterios;
        this.loading = false;
      });
  }

  onFileChanged(event) {
    this.imagem = event.target.files[0];
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/cadastro-ocorrencia/cadastro-ocorrencia.component.ts